import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { Button, Modal, Col, Row, Table, Spinner } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import _ from "lodash";
import ApiAgent from "../../../core/api/api.agent";
import SwalMessage from "../_Components/SwalMessage";
import SelectComponent from "../_Components/ReactSelectComponent";

export const ViewAndUpdateAgent = ({ showModalAgent, setShowModalAgent, selectedAgent }) => {
  const [agentApprovalType, setAgentApprovalType] = useState([]);
  const [historyAgentData, setHistoryAgentData] = useState([]);
  const [fileGet, setFileGet] = useState([]);
  const [showImage, setshowImage] = useState("");


  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    setValue,
  } = useForm({ defaultValues: { id: 0 } });
  const handleClose = () => {
    setShowModalAgent(false);
  };
  useEffect(() => {
    (async () => {
      try {
        if (selectedAgent != 0) {
          const responseEnum = await ApiAgent.getAgentApprovalStatus();
          setAgentApprovalType(responseEnum.data);

          const response = await ApiAgent.getAllAgentById(selectedAgent);
          if (response.succeeded == true) {
            // مقدار اولیه
            setValue("companyName", response.data.companyName);
            setValue("companyNationalId", response.data.companyNationalId);
            setValue("licenseTypeS", response.data.licenseTypeS);
            setValue("city", response.data.city.name);
            setValue("cEOFirstName", response.data.ceoFirstName);
            setValue("cEOLastName", response.data.ceoLastName);
            setValue("cEOIdentityNumber", response.data.ceoIdentityNumber);
            setValue("status", responseEnum.data?.map((item) => ({
              value: item.id,
              label: item.title,
            })).find(item => item.value == response.data.agentApprovalStatus));
            setValue("id", response.data.agentId);
              setHistoryAgentData(response.data.statusJsonArray);
              response?.data?.files.map((item) => {
                  let obj = {
                      id: selectedAgent,
                      fileId: item,
                      access: 1,
                  };
                  ApiAgent.getFileOfFileManager(obj)
                      .then((response) => {
                          let objectURL = URL.createObjectURL(new Blob([response]));
                          setFileGet((oldFileGet) => [...oldFileGet, objectURL]);
                      })
                      .catch((error) => {
                          console.error(`onRejected function called: ${error.message}`);
                      });

                  return;
              });
          }
        }
      } catch (error) {
      }
    })();
    return () => { };
  }, []);

  const onSubmit = async (data) => {
    try {
      const response = await ApiAgent.updateAgent({
        id: data.id,
        agentApprovalStatus: data.status?.value,
        discription: data.description,
      });
      if (response.succeeded) setShowModalAgent(false)
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
      if (response.succeeded == true) document.getElementById("submitButton").click();
    } catch (error) {
    }
  };

  const viewImageFile = (urlImage) => (event) => {
    setshowImage(urlImage);
  };

  return (
    <div>
      <Modal centered size="lg" show={showImage != "" ? true : false} onHide={handleClose}>
        <Modal.Header closeButton>{/* <Modal.Title>ایجاد گروه تخفیف </Modal.Title> */}</Modal.Header>
        <Modal.Body></Modal.Body>
        <img src={showImage} width="80%" height="80%"></img>

        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Start Modal */}
      {/* <Modal centered size='md' show={show} onHide={handleClose}> */}
      <Modal centered size="md" show={showModalAgent} onHide={handleClose}>
        <form id="form" onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title> بررسی و تغییر وضعیت نماینده</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs="12">
                <Controller
                  name="companyName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="companyNationalId"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شناسه ملی شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="licenseTypeS"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="مجوز شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="city"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شهر شرکت"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOFirstName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOLastName"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="نام خانوادگی مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <Controller
                  name="cEOIdentityNumber"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="شماره ملی مدیر عامل"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      value={value || ""}
                      onInput={onChange}
                      disabled
                    />
                  )}
                />
              </Col>
              <Col xs="12">
                <span>تصویر مدارک ارسال شده:</span>

                {fileGet?.length > 0 ? (
                  <Row className="d-flex flex-wrap justify-content-center mt-1 ">
                    {fileGet.map((item, index) => (
                      <span onClick={viewImageFile(item)} style={{ cursor: "pointer" }}>
                        فایل{++index} -{" "}
                      </span>

                    ))}
                  </Row>
                ) : (
                  <p>تصویر مدارک پیدا نشد .</p>
                )}
                <hr></hr>
              </Col>
              <Col xs="12">
                <Controller
                  name="status"
                  control={control}
                  render={({ field }) => (
                    <SelectComponent
                      options={agentApprovalType?.map((item) => ({
                        value: item.id,
                        label: item.title,
                      }))}
                      placeholder="وضعیت نماینده"
                      className="w-100 mt-5"
                      variant="outlined"
                      size="small"
                      field={field}
                    />
                  )}
                />
              </Col>
              <Col xs="12" sm="12" lg="12">
                <Controller
                  name="description"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <TextField
                      label="توضیحات"
                      type="text"
                      rows={3}
                      multiline
                      variant="outlined"
                      margin="normal"
                      className="w-70"
                      // placeholder="توضیحات"
                      value={value || ""}
                      onInput={onChange}
                      sx={{
                        ".css-1b76txz-MuiInputBase-root-MuiOutlinedInput-root": {
                          padding: "8.5px 14px 8.5px 0px !important",
                        }
                      }}
                    />
                  )}
                />
              </Col>
            </Row>
            <Table striped hover responsive>
              <thead>
                <tr>
                  <th>#</th>
                  <th>وضعیت</th>
                  <th>توضیحات</th>
                  <th>توسط</th>
                  <th>تاریخ</th>
                </tr>
              </thead>
              <tbody>
                {historyAgentData?.map((item, index) => (
                  <tr key={index}>
                    <td>{index}</td>
                    <td>{item.agentApprovalStatusS}</td>
                    <td>{item.discription}</td>
                    <td>{item.createdByS}</td>
                    <td>{item.createdS}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
              <SaveIcon /> ذخیره
            </Button>
            <Button variant="danger" onClick={handleClose}>
              <CloseIcon /> بستن
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
};
